import { Injectable } from '@angular/core';
import { UserList } from '../include/structures'
import { WSService } from '../include/service'
import { Observable } from 'rxjs';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root'
})

export class UserListService  extends WSService<UserList> {

  constructor() { super("userlists") }
  static usergroups:UserList[]=[];
  
  getList():Observable<UserList[]>{
    return Globals.ws.requestUrl<UserList[]>("userlists","getItems",[],true,0,1000000);
  }

  getUsersByIdList(id):Observable<UserList[]>{
    return Globals.ws.requestUrl<UserList[]>("userlists","getUsersByIdList",[id],true,0,1000000);
  }
}
